(function ($) {
  DJ.addBehavior('maxChars', '[data-max-chars]', {
    attach: function () {
      const field = this;
      const label = $(field).closest('.form-item').find('label')[0];
      const charsRemain = document.createElement('span');
      const limit = field.getAttribute('data-max-chars') || 300;
      const ambitiousForm = document.querySelector('.node-project-idea-ambitious-project-form');
      let ckeIframeBody = null;

      /**
       * Create div to display the amount of chars left to input.
       * Place this div under the field.
       */
      charsRemain.classList.add('max-chars-amount');
      charsRemain.textContent = ` (${limit} caractères)`;

      if (label) {
        label.appendChild(charsRemain);
      }

      /**
       * Count chars depending on the set limit.
       */
      const countCharacters = () => {
        let counter = 0;

        if (field.value.length > limit) {
          field.value = field.value.substring(0, limit);
        } else {
          counter = (limit - (field.value.length));
        }

        if (counter === 1) {
          charsRemain.textContent = ` (${counter} caractère)`;
        } else {
          charsRemain.textContent = ` (${counter} caractères)`;
        }
      };

      const countCkeCharacters = () => {
        let counter = 0;

        if (ckeIframeBody) {
          if (ckeIframeBody.innerText.length <= limit) {
            counter = (limit - (ckeIframeBody.innerText.length));
          }
        }

        if (counter === 1) {
          charsRemain.textContent = ` (${counter} caractère)`;
        } else {
          charsRemain.textContent = ` (${counter} caractères)`;
        }
      };

      /**
       * Add event listeners to the field with the count function.
       */
      let waitForCke;
      if (ambitiousForm) {
        if (field.tagName === 'TEXTAREA') {
          let ckeTimeout = setTimeout(waitForCke = () => {
            const ckeIframe = $(field).closest('.form-item').find('.cke_wysiwyg_frame')[0]
              && $(field).closest('.form-item').find('.cke_wysiwyg_frame')[0].contentWindow;
            ckeIframeBody = ckeIframe ? ckeIframe.document.body : null;

            if (ckeIframeBody) {
              clearTimeout(ckeTimeout);
              countCkeCharacters();

              const config = { attributes: true, childList: true, subtree: true };
              const observer = new MutationObserver(countCkeCharacters);
              observer.observe(ckeIframeBody, config);
            } else {
              ckeTimeout = setTimeout(waitForCke, 1000);
            }
          }, 1000);
        }

        if (field.tagName === 'INPUT') {
          countCharacters();
          field.addEventListener('input', countCharacters);
        }
      } else {
        countCharacters();
        field.addEventListener('input', countCharacters);
      }
    }
  });
})(jQuery);
